import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 42 43"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "21",
      cy: "21.048",
      r: "17.5",
      stroke: "#59AD3B",
      "stroke-opacity": ".17",
      "stroke-width": "7"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#59AD3B",
      "fill-rule": "evenodd",
      d: "M21 35.048c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14Zm0 7c11.598 0 21-9.402 21-21s-9.402-21-21-21-21 9.402-21 21 9.402 21 21 21Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "21",
      cy: "20.548",
      r: "16",
      fill: "#59AD3B"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#F8F8F8",
      "stroke-width": "6",
      d: "m11 19.548 7.586 8 12.414-14"
    }, null, -1)
  ]))]))
}
export default { render: render }